(function () {
  var FLAG = 'overlayConfirmed';

  function closestConfirmForm(el) {
    return el.closest('form[data-overlay-confirm="true"]');
  }

  function openModal(form) {
    var modalId = form.getAttribute('data-overlay-modal-id');
    var modal = modalId && document.getElementById(modalId);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overlay-confirm-locked');
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overlay-confirm-locked');
  }

  // Both listeners run on document, in the capture phase, so they see the
  // event before any handler the theme has bound on the form or button
  // itself — regardless of whether the theme's add-to-cart code listens
  // for a form "submit" or a button "click".
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('data-overlay-confirm') !== 'true') return;
      if (form.dataset[FLAG] === 'true') return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      openModal(form);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var submitEl = e.target.closest('[type="submit"]');
      if (!submitEl) return;
      var form = closestConfirmForm(submitEl);
      if (!form) return;
      if (form.dataset[FLAG] === 'true') return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      openModal(form);
    },
    true
  );

  function openCartDrawer() {
    var trigger = document.querySelector('.js-mini-cart-trigger');
    if (trigger) {
      trigger.click();
    } else {
      window.location.href = '/cart';
    }
  }

  document.addEventListener('click', function (e) {
    var closeTrigger = e.target.closest(
      '.overlay-confirm__close, .overlay-confirm__backdrop'
    );
    if (closeTrigger) {
      var modalToClose = closeTrigger.closest('.overlay-confirm');
      if (modalToClose) closeModal(modalToClose);
      return;
    }

    var switchLink = e.target.closest('.overlay-confirm__btn--switch');
    if (switchLink) {
      var variantId = switchLink.getAttribute('data-sign-variant-id');
      if (variantId && !switchLink.classList.contains('is-loading')) {
        e.preventDefault();
        switchLink.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            var switchModal = switchLink.closest('.overlay-confirm');
            if (switchModal) closeModal(switchModal);
            openCartDrawer();
          })
          .catch(function () {
            window.location.href = switchLink.href;
          })
          .finally(function () {
            switchLink.classList.remove('is-loading');
          });
      }
      return;
    }

    var proceed = e.target.closest('.overlay-confirm__btn--primary');
    if (!proceed) return;

    var modal = proceed.closest('.overlay-confirm');
    if (!modal) return;
    var form = document.getElementById(modal.getAttribute('data-form-id'));
    closeModal(modal);
    if (!form) return;

    form.dataset[FLAG] = 'true';
    var submitEl = form.querySelector('[type="submit"]');
    if (submitEl) {
      submitEl.click();
    } else if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var openModalEl = document.querySelector('.overlay-confirm.is-open');
    if (openModalEl) closeModal(openModalEl);
  });
})();
